export default "__VITE_ASSET__BnFD3BDx__"